// extracted by mini-css-extract-plugin
export default {"tooltip":"dT-z","arrow":"eT-z"};